const t = "Modalt fönster", s = "Stäng", e = {
  title: t,
  close: s
};
export {
  s as close,
  e as default,
  t as title
};
